import React from "react";
import { Margin, usePDF } from "react-to-pdf";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Phulucttdkchitiet from "components/Tonghopbaocao/Trungtamdangkiem/Phulucttdkchitiet.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

export default function Phulucttdk() {
  const [thangnam, setThangnam] = React.useState(dayjs());
  const { toPDF, targetRef } = usePDF({
    filename: "Baocaohoatdongvantai.pdf",
    page: { margin: Margin.MEDIUM },
  });
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "15%" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Chọn tháng năm"
              value={thangnam}
              onChange={(newValue) => {
                setThangnam(newValue);
              }}
              format="MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "27px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "13%", marginLeft: "10px" }}>
          <Button
            color="primary"
            variant="contained"
            style={{ height: 27 }}
            onClick={toPDF}
          >
            Tải file PDF
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <div ref={targetRef} style={{ height: "auto" }}>
          <Phulucttdkchitiet thangnam={thangnam} />
        </div>
      </GridItem>
    </GridContainer>
  );
}
